// FormDatePicker component

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import InputMask from 'react-input-mask'

import IntlUtil from '../../../lib/intlutil.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import DateRangePicker from '../../form/daterange_picker/daterange_picker.jsx'
import Header from '../../form/daterange_picker/daterange_header.jsx'
import Calendar from '../../form/daterange_picker/daterange_calendar.jsx'

class ScheduleDatePicker extends DateRangePicker {
  static get propTypes () {
    return {
      value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string
      ]),
      label: PropTypes.string,
      name: PropTypes.string,
      icon: PropTypes.string,
      size: PropTypes.string,
      onChange: PropTypes.func,
      required: PropTypes.bool,
      dateFormat: PropTypes.string,
      active: PropTypes.bool,
      hideInput: PropTypes.bool,
      onValidateDate: PropTypes.func,
      placeholder: PropTypes.string,
      onFocus: PropTypes.func,
      onNavigateMonth: PropTypes.func,
      weekStats: PropTypes.array,
      showWeekNo: PropTypes.bool,
      formatDay: PropTypes.bool,
      displayDate: PropTypes.any,
      errorMsg: PropTypes.string,
      selectionStart: PropTypes.any,
      selectionEnd: PropTypes.any,
      isSingleDate: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      value: '',
      label: '',
      name: '',
      icon: '',
      size: '',
      onChange: null,
      required: false,
      dateFormat: 'DD-MM-YYYY',
      active: false,
      hideInput: false,
      onValidateDate: null,
      placeholder: '',
      onFocus: null,
      onNavigateMonth: null,
      weekStats: [],
      showWeekNo: false,
      displayDate: null,
      errorMsg: '',
      selectionStart: 0,
      selectionEnd: 0,
      isSingleDate: false
    }
  }

  constructor (props) {
    super(props)

    this._references = {
      calendar: React.createRef()
    }
  }

  componentDidMount () {
    if (
      this.props.selectionStart &&
      !this.props.selectionEnd &&
      this._references.calendar.current
    ) {
      this._references.calendar.current.setSelectionEnabled(true)
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    let bUpdateState = false
    const stateObj = {}

    if (
      this.props.selectionStart !== nextProps.selectionStart &&
      nextProps.selectionStart &&
      !nextProps.selectionEnd
    ) {
      bUpdateState = true
      stateObj.selectionStart = nextProps.selectionStart
      stateObj.selectionEnd = 0

      if (this._references.calendar.current) {
        this._references.calendar.current.setSelectionEnabled(true)
      }
    }

    if (this.props.startDate !== nextProps.startDate) {
      bUpdateState = true
      stateObj.date = (nextProps.startDate || new Date()).getTime()
      stateObj.startDate = nextProps.startDate
    }

    if (this.props.endDate !== nextProps.endDate) {
      bUpdateState = true
      stateObj.endDate = nextProps.endDate
    }

    if (bUpdateState) {
      this.setState(stateObj)
    }
  }

  render () {
    const { icon, size, hideInput, displayDate } = this.props
    const _classNames = classnames(
      'form-datepicker',
      'schedule-datepicker',
      {
        'form-datepicker_hideinput': hideInput
      },
      size ? `form-datepicker_${size}` : null
    )
    const _iconClassName = icon || 'form-calendar'
    const _fieldClassnames = classnames('form-datepicker-field', {
      has_error: this.state.error,
      showinput: this.state.bShowInput
    })

    let dateInfo = ''
    let startData = ''

    if (displayDate) {
      startData = DateUtil.getDisplayDate(this.props.displayDate)
      dateInfo = `${startData}`
    }

    return (
      <div className={_classNames}>
        <div className={_fieldClassnames}>
          <div
            className='input-prefix-icon'
            onClick={this._onShowDatepicker.bind(this)}
          >
            <span className={`icon icon-${_iconClassName} normal`} />
          </div>
          <div className='rdt datepicker-input'>
            <input
              type='text'
              className='form-control'
              value={dateInfo}
              placeholder={IntlUtil.convertMessage(this.props.placeholder)}
              onFocus={this._onFocusInput.bind(this)}
            />
          </div>
          {this._renderDateRange()}
          {this.state.bShowInput ? (
            <div className='inputedit'>
              <InputMask
                mask='99-99-9999'
                autoFocus={this._bFocus}
                placeholder={IntlUtil.convertMessage(this.props.placeholder)}
                onFocus={this.props.onFocus}
                required={this.props.required}
                value={this.state.value}
                alwaysShowMask={false}
                maskChar={null}
                onChange={this._onChangeInput.bind(this)}
              />
            </div>
          ) : null}
          {!this.props.errorMsg && this.props.label ? (
            <span className='input-placeholder-label'>
              <IntlMessage ident={this.props.label} />
            </span>
          ) : (
            this.props.errorMsg && (
              <span className='input-error-label'>
                <IntlMessage ident={this.props.errorMsg} />
              </span>
            )
          )}
        </div>
      </div>
    )
  }

  _renderDateRange () {
    const {
      date,
      selectionStart,
      selectionEnd,
      active,
      startDate,
      endDate
    } = this.state
    const className = `daterangewrap${active ? ' active' : ''}`

    return (
      <div className='daterange-picker'>
        <div className='form-input input'>
          <span className='iconcont'>
            <i className='icon icon-phase-calendar' />
          </span>
          <input
            className='input input-element dropdown-value'
            type='text'
            placeholder={IntlUtil.convertMessage('common.list.fromTo')}
            onClick={this._onClick.bind(this)}
            autoFocus
            onFocus={this._onFocus.bind(this)}
            onKeyDown={this._onKeyDown.bind(this)}
            onChange={this._onChange.bind(this)}
            onBlur={this._onBlur.bind(this)}
          />
        </div>
        <div className={className}>
          <Header
            date={date}
            prevMonth={this.prevMonth.bind(this)}
            nextMonth={this.nextMonth.bind(this)}
          />
          <Calendar
            ref={this._references.calendar}
            date={date}
            isSingleDate={this.props.isSingleDate}
            onSelect={this._onSelect.bind(this)}
            onSelectSingleDate={this._onSelectSingleDate.bind(this)}
            indexStart={selectionStart}
            indexEnd={selectionEnd}
            startDate={startDate}
            endDate={endDate}
            disabledPeriods={this.props.disabledPeriods}
            highlightedPeriods={this.props.highlightedPeriods}
            setRange={this.setRange.bind(this)}
            onError={this.props.onError}
          />
        </div>
      </div>
    )
  }

  setRange (selectionStart = 0, selectionEnd = 0) {
    const stateObj = { selectionStart, selectionEnd, error: false }
    this.setState(stateObj)

    if (this.props.onChangeRange) {
      this.props.onChangeRange(selectionStart, selectionEnd)
    }
  }

  validate () {
    return true
  }

  showError () {
    this.setState({ error: true })
  }

  clearError () {
    this.setState({ error: true })
  }

  /* Private Functions */
  _onFocusInput () {
    this.show()
  }

  _onShowDatepicker (event) {
    event.preventDefault()
    this.show()
  }

  _onSelect (bselect) {
    if (bselect === false) {
      this.setState({ active: bselect })
      if (this.props.onSelect) {
        const selectionStart = this.state.selectionStart
          ? DateUtil.getUTCDateFromDate(this.state.selectionStart)
          : 0
        const selectionEnd = this.state.selectionEnd
          ? DateUtil.getUTCDateFromDate(this.state.selectionEnd)
          : 0

        this.props.onSelect(selectionStart, selectionEnd)
      }
    } else {
      this.setState({ startDate: null, endDate: null })
    }
  }

  _onSelectSingleDate (date) {
    if (this.props.onSelect) {
      this.props.onSelect(date, 0)
      this.setState({ active: false })
    }
  }
}

export default ScheduleDatePicker
